import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m13.84 12 9.906-9.905c240824.254-.339.339-.888 0-1.227l-.614-.614a.867.867 0 0 0-1.227 0L12 10.16 2.095.262a.867.867 0 0 0-1.227 0L.254.875a.867.867 0 0 0 0 1.228L10.16 12 .262 21.905a.867.867 0 0 0 0 1.227l.613.613c.34.34.888.34 1.228 0L12 13.842l9.905 9.905c.339.339.888.339 1.227 0l.613-.614a.867.867 0 0 0 0-1.227z" }, null, -1)
  ])))
}
export default { render: render }